import EventEmitter from 'eventemitter3';

type AppEvents = {
  appLoaded: (appId: number) => void;
};

const events = new EventEmitter<AppEvents>();

export const eventsService = {
  addListener: <K extends keyof AppEvents>(event: K, fn: AppEvents[K]) => {
    events.on(event, fn as AppEvents[keyof AppEvents]);
  },
  removeListener: <K extends keyof AppEvents>(event: K, fn: AppEvents[K]) => {
    events.off(event, fn as AppEvents[keyof AppEvents]);
  },
  emit: <K extends keyof AppEvents>(event: K, ...args: Parameters<AppEvents[K]>) => {
    events.emit(event, ...args);
  },
};
